<template lang="pug">
  v-snackbar(
    :app="!!snackbar"
    :value="!!snackbar"
    @input="remove"
    :elevation="3"
    fixed
    :light="theme.dark"
    bottom
    style="z-index: 6")
    template(v-if="snackbar") {{ snackbar.content }}
    // template(
      v-if="snackbar"
      v-slot:action="{ attrs }")
      v-btn(
        @click="remove"
        color="primary"
        v-bind="attrs"
        text) Fermer
</template>

<script>
import { reactive, toRefs } from '@vue/composition-api'
import { state } from '..'
import { state as stateShortcut } from '../../bottom-shortcut/'
import { theme } from '@iez/core'
import { VSnackbar, VBtn } from 'vuetify/lib'

export default {
  components: {
    VSnackbar, VBtn
  },

  setup () {
    return {
      ...toRefs(state),
      stateShortcut,
      remove: () => {
        if (state.snackbar.remove) {
          state.snackbar.remove()
        }
      },
      theme
    }
  }
}
</script>

<style>
.v-snack__wrapper {
  width: 100% !important;
}
</style>
